import { getNewPasswordSchemaField, passwordValidation } from "@/constants/schema";
import { object, string, ref } from "yup";

export const changePasswordSchema = object({
    currentPassword: passwordValidation,
    newPassword: getNewPasswordSchemaField("Please enter your new password"),
    confirmPassword: string().required("Please confirm your new password")
        .oneOf([ref('newPassword')], 'Entered passwords do not match')
});
